import { createFileRoute } from '@tanstack/react-router';

import {
  isAnyInventoryItemFilterActive,
  parseInventoryItemsRouteSearch,
} from '../../modules/inventory/inventory-item-filter-state/route-search.js';
import { InventoryItemsPage } from '../../modules/inventory/inventory-items-page.js';

export const Route = createFileRoute('/inventory/')({
  validateSearch: parseInventoryItemsRouteSearch,
  component: InventoryIndexRoute,
});

// eslint-disable-next-line react-refresh/only-export-components
function InventoryIndexRoute() {
  const search = Route.useSearch();
  return (
    <InventoryItemsPage search={search} anyFilterActive={isAnyInventoryItemFilterActive(search)} />
  );
}
